var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWishlistPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    width: 84,
    height: 112,
    viewBox: "0 0 84 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M0 0H84V112H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M41.509 66.216l-6.989-7.17c-2.023-2.073-2.027-5.425-.009-7.493a5.106 5.106 0 016.98-.333 5.109 5.109 0 016.989.342c2.023 2.073 2.027 5.425.009 7.493l-6.98 7.16z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistPlaceholder);
export default __webpack_public_path__ + "static/media/wishlist-placeholder.8f848a4cf6d54c48de3900e3b3fac904.svg";
export { ForwardRef as ReactComponent };